import React from "react";
import { Link } from "react-router-dom";
import { TERMS_HTML, TERMS_VERSION, TERMS_EFFECTIVE_DATE } from "../lib/terms";
import { sanitizeHtml } from "../lib/sanitize";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-16" data-testid="terms-page">
      <div className="font-mono-cal text-[11px] uppercase tracking-[0.2em] text-[#666] mb-4">[LEGAL]</div>
      <h1 className="font-display font-bold text-5xl tracking-tight mb-2">Terms &amp; Conditions</h1>
      <p className="text-[#666] mb-10 font-mono-cal text-xs">Version {TERMS_VERSION} · Effective {TERMS_EFFECTIVE_DATE}</p>
      <article
        className="cal-prose"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(TERMS_HTML) }}
      />
      <div className="mt-12 flex gap-3">
        <Link to="/register" className="cal-btn" data-testid="terms-back-register">Back to register →</Link>
        <Link to="/" className="cal-btn cal-btn-ghost">Home</Link>
      </div>
    </div>
  );
}
